import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

let serverUrl = appConfig.server_url

export const state = {
  organizationCharts: { results: [] },
  positions: { results: [] },
  areas: { results: [] },
  submitting: false,
  deleting: false,
}

export const getters = {
  organizationCharts: (state) => state.organizationCharts,
  positions: (state) => state.positions,
  areas: (state) => state.areas,
  submitting: (state) => state.submitting,
  deleting: (state) => state.deleting,
}

export const mutations = {
  CACHE_ORGANIZATION_CHARTS(state, data) {
    state.organizationCharts = data
  },
  CACHE_POSITIONS(state, data) {
    state.positions = data
  },
  CACHE_AREAS(state, data) {
    state.areas = data
  },
  SUBMITTING(state, value) {
    state.submitting = value
  },
  DELETING(state, deleting) {
    state.deleting = deleting
  },
}

export const actions = {
  async fetchOrganizationCharts({ commit }, query = '') {
    try {
      const res = await axios.get(
        `${serverUrl}/assessment/organizationchart/${query}`
      )
      commit('CACHE_ORGANIZATION_CHARTS', res.data)
      return { error: null, data: res.data }
    } catch (error) {
      return { error, data: null }
    }
  },

  async fetchOrganizationChartsSelector(_, query = '') {
    try {
      return await axios.get(
        `${serverUrl}/assessment/organizationchart/${query}&page_size=9999`
      )
    } catch (error) {
      throw Error(error)
    }
  },

  async createUpdateOrganizacionChart({ commit }, { method, payload }) {
    const url =
      method === 'put'
        ? payload.url
        : `${serverUrl}/assessment/organizationchart/`

    commit('SUBMITTING', true)
    try {
      const res = await axios[method](url, payload)
      commit('SUBMITTING', false)
      return { error: null, data: res.data }
    } catch (error) {
      commit('SUBMITTING', false)
      return { error, data: null }
    }
  },

  async deleteOrganizationChart({ commit }, url) {
    commit('DELETING', true)
    try {
      const res = await axios.delete(url)
      commit('DELETING', false)
      return { success: true, status: res.status }
    } catch (error) {
      commit('DELETING', false)
      return { success: false, error }
    }
  },

  async fetchPositions({ commit }, query = '') {
    try {
      const res = await axios.get(
        `${serverUrl}/company/position/fetch_all/${query}`
      )
      commit('CACHE_POSITIONS', { results: res.data })
      return { error: null, data: res.data }
    } catch (error) {
      return { error, data: null }
    }
  },

  async createUpdatePosition(_, { method, payload }) {
    const url =
      method === 'put' ? payload.url : `${serverUrl}/company/position/`

    try {
      const res = await axios[method](url, payload)
      return { error: null, data: res.data }
    } catch (error) {
      return { error, data: null }
    }
  },

  async fetchAreas({ commit }, query = '') {
    try {
      const res = await axios.get(`${serverUrl}/company/area/${query}`)
      commit('CACHE_AREAS', res.data)
      return { error: null, data: res.data }
    } catch (error) {
      return { error, data: null }
    }
  },

  async createUpdateArea(_, { method, payload }) {
    const url = method === 'put' ? payload.url : `${serverUrl}/company/area/`

    try {
      const res = await axios[method](url, payload)
      return { error: null, data: res.data }
    } catch (error) {
      return { error, data: null }
    }
  },
}
